<script lang="ts">
	import { ClientVelatlasLoggerApi } from '$lib/api/velatlas/velatlas.loggerApi.client';
	import type { Faq } from '$lib/features/_other/faq';
	import { ANALYTICS_EVENT_NAMES } from '$lib/statics';

	let { faqs }: { faqs: Faq[] } = $props();

	const analyticsApi = new ClientVelatlasLoggerApi();

	let openIndex = $state<number | null>(null);

	function toggle(index: number) {
		openIndex = openIndex === index ? null : index;

		if (openIndex !== null) {
			analyticsApi.sendAnalytics({
				event: ANALYTICS_EVENT_NAMES.readMore,
				payload: { type: 'faq', question: faqs[openIndex].question }
			});
		}
	}
</script>

<div id="faq" class="flex flex-col gap-3">
	<dl class="space-y-3">
		{#each faqs as faq, index}
			{const isOpen = $derived<boolean>(openIndex === index)}
			<div
				class={{
					'overflow-hidden rounded-box border transition-all duration-300': true,
					'border-primary/40 bg-primary/5 shadow-md shadow-primary/10': isOpen,
					'border-base-content/10 bg-base-200 hover:border-primary/25': !isOpen
				}}
			>
				<dt>
					<button
						class="group flex w-full cursor-pointer items-center justify-between gap-4 px-6 py-5 text-left"
						type="button"
						aria-expanded={isOpen}
						aria-controls="faq-answer-{index}"
						onclick={() => toggle(index)}
					>
						<h3
							class={{
								'text-base leading-snug font-semibold transition-colors duration-200': true,
								'text-primary': isOpen,
								'text-base-content group-hover:text-primary': !isOpen
							}}
						>
							{faq.question}
						</h3>

						<span
							class={{
								'flex size-7 shrink-0 items-center justify-center rounded-full transition-all duration-300': true,
								'rotate-45 bg-primary text-primary-content': isOpen,
								'bg-base-content/10 text-base-content/60 group-hover:bg-primary/20 group-hover:text-primary': !isOpen
							}}
							aria-hidden="true"
						>
							+
						</span>
					</button>
				</dt>

				<dd
					id="faq-answer-{index}"
					class={{
						'grid transition-[grid-template-rows] duration-300 ease-out': true,
						'grid-rows-[1fr]': isOpen,
						'grid-rows-[0fr]': !isOpen
					}}
				>
					<div class="overflow-hidden">
						<div class="px-6 pb-5" inert={!isOpen}>
							<div class="mb-4 h-px w-full bg-primary/35"></div>
							<p class="text-sm leading-relaxed text-base-content/70">{faq.answer}</p>
						</div>
					</div>
				</dd>
			</div>
		{/each}
	</dl>

	<p class="mt-3 text-center text-xs leading-relaxed text-base-content/70">
		While we strive to keep this information accurate and up to date, we recommend verifying any details independently before
		making decisions based on them.
	</p>
</div>
